import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StammdatenService } from '../../stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Client } from '../../../client/classes/client';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';
import { KieneSession } from '../../../../services/local-storage/kiene-session';
import { AppService } from '../../../../services/app/app.service';
import { MatDialog } from '@angular/material/dialog';
import { VvvoHinzufuegenHitDialogComponent } from '../vvvo-hinzufuegen-hit-dialog/vvvo-hinzufuegen-hit-dialog.component';
import { HitLoginResponse } from '../../../../hit/hit-registrierung/classes/hit-login-response';
import { VVVODetailsDialogComponent } from '../vvvodetails-dialog/vvvodetails-dialog.component';
import { HitPinAenderDialogComponent } from '../hit-pin-aender-dialog/hit-pin-aender-dialog.component';
import { LieferantDetailsDialogComponent } from '../../lieferant/lieferant-details-dialog/lieferant-details-dialog.component';
import { Futtermittellieferant } from '../../lieferant/lieferant';
import { forkJoin } from 'rxjs';
import { ExternTierarztDetailsDialogComponent } from '../../extern-tierarzt/extern-tierarzt-details-dialog/extern-tierarzt-details-dialog.component';
import { ExternTierarzt } from '../../extern-tierarzt/extern-tierarzt';
// import { PhitoStripeService } from '../../../../services/phito-stripe.service';

@Component({
    selector: 'kiene-vvvo-uebersicht',
    templateUrl: './vvvo-uebersicht.component.html',
    styleUrls: ['./vvvo-uebersicht.component.scss'],
})
export class VvvoUebersichtComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input('showReturnButton') public showReturnButton = true;

    vvvoSubscription: Subscription;
    searchSubscription: Subscription;

    vvvos: Client[] = [];
    meineVvvos: Client[] = [];
    freigegebeneVvvos: Client[] = [];
    selectedView: 'meine' | 'freigegebene' = 'meine';
    columns: {
        key: string;
        label: string;
        widthPx: number;
        alwaysVisible?: boolean;
        available: boolean;
        visible: boolean;
        dataKeys?: string[];
    }[] = [
        { key: 'bezeichnung', label: 'Betrieb', widthPx: 220, alwaysVisible: true, available: true, visible: true },
        { key: 'vvvo', label: 'VVVO', widthPx: 150, alwaysVisible: true, available: true, visible: true },
        { key: 'betriebsart', label: 'Betriebsart', widthPx: 240, alwaysVisible: true, available: true, visible: true },
        { key: 'adresse', label: 'Adresse', widthPx: 340, alwaysVisible: true, available: true, visible: true },
        { key: 'email', label: 'E-Mail', widthPx: 220, alwaysVisible: true, available: true, visible: true },
        { key: 'telefon', label: 'Telefon', widthPx: 160, available: false, visible: false, dataKeys: ['telefon', 'telefon_1'] },
        { key: 'telefon_2', label: 'Telefon 2', widthPx: 160, available: false, visible: false, dataKeys: ['telefon_2'] },
        { key: 'mobil', label: 'Mobil', widthPx: 160, available: false, visible: true, dataKeys: ['mobil', 'mobil_1'] },
        { key: 'mobil_2', label: 'Mobil 2', widthPx: 160, available: false, visible: true, dataKeys: ['mobil_2'] },
        { key: 'fax', label: 'Fax', widthPx: 160, available: false, visible: false, dataKeys: ['fax'] },
        { key: 'ortsteil', label: 'Ortsteil', widthPx: 160, available: false, visible: true, dataKeys: ['ortsteil'] },
        { key: 'sgs_nummer', label: 'SGS Nr.', widthPx: 150, available: false, visible: false, dataKeys: ['sgs_nummer'] },
        {
            key: 'belege_email',
            label: 'Belege E-Mail',
            widthPx: 220,
            available: false,
            visible: false,
            dataKeys: ['belege_email'],
        },
        { key: 'kp_abw_email', label: 'Rechnung E-Mail', widthPx: 220, available: false, visible: false, dataKeys: ['kp_abw_email'] },
        {
            key: 'futtermittellieferant',
            label: 'Futtermittellieferant',
            widthPx: 220,
            available: false,
            visible: true,
            dataKeys: ['futtermittellieferant'],
        },
        {
            key: 'extern_tierarzt',
            label: 'Tierarzt',
            widthPx: 200,
            available: false,
            visible: true,
            dataKeys: ['extern_tierarzt'],
        },
        { key: 'wirtschaftsjahr', label: 'Wirtschaftsjahr', widthPx: 140, available: false, visible: true, dataKeys: ['wirtschaftsjahr'] },
    ];
    readonly actionColumnWidthPx = 44;
    readonly desktopColumnGapPx = 12;

    kieneSession: KieneSession;
    searchControl = new FormControl();
    sortKey = 'bezeichnung';
    sortDirection: 'asc' | 'desc' = 'asc';
    expandedKundeId: number | null = null;
    horizontalScrollWidth = 0;
    showHorizontalScrollbar = false;
    bottomScrollbarLeft = 0;
    bottomScrollbarWidth = 0;
    private syncFromTable = false;
    private syncFromBottom = false;
    private tableResizeObserver?: ResizeObserver;
    private tableVisibilityObserver?: IntersectionObserver;
    private syncTimeoutHandles: number[] = [];
    private initialSyncIntervalHandle?: number;
    @ViewChild('tableScrollContainer') tableScrollContainer: ElementRef<HTMLDivElement>;
    @ViewChild('bottomScrollbar') bottomScrollbar: ElementRef<HTMLDivElement>;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly stammdatenService: StammdatenService,
        private readonly messageService: MessageService,
        private readonly localStorageService: LocalStorageService,
        private readonly appService: AppService,
        // private readonly stripeService: PhitoStripeService,
        private readonly dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.kieneSession = this.localStorageService.getCurrentUser();
        this.searchSubscription = this.searchControl.valueChanges.subscribe(() => {
            this.scheduleHorizontalScrollbarSync();
        });
        this.ladeVvvos();
    }

    ngOnDestroy(): void {
        this.vvvoSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe();
        this.tableResizeObserver?.disconnect();
        this.tableVisibilityObserver?.disconnect();
        this.clearScheduledScrollbarSync();
        this.stopInitialSyncLoop();
    }

    ngAfterViewInit(): void {
        this.initTableResizeObserver();
        this.initTableVisibilityObserver();
        this.startInitialSyncLoop();
    }

    ladeVvvos(): void {
        this.vvvoSubscription?.unsubscribe();
        const currentKundeId = this.stammdatenService.getAusgewaehlteVvvo()?.kunde_id;
        this.vvvoSubscription = forkJoin({
            meine: this.stammdatenService.ladeMeineVvvos(''),
            freigegebene: this.stammdatenService.ladeFreigegebeneVvvos(currentKundeId, ''),
        }).subscribe({
            next: ({ meine, freigegebene }) => {
                this.meineVvvos = meine?.records || [];
                const meineIds = new Set(this.meineVvvos.map(v => v?.kunde_id));
                this.freigegebeneVvvos = (freigegebene?.records || []).filter(v => !meineIds.has(v?.kunde_id));
                this.vvvos = [...this.meineVvvos, ...this.freigegebeneVvvos];
                this.updateOptionalColumnsAvailability();
                this.initTableResizeObserver();
                this.initTableVisibilityObserver();
                this.startInitialSyncLoop();
            },
            error: err => this.messageService.errorMessage('Fehler beim Laden der Betriebe!', err),
        });
    }

    vvvoAnlegen() {
        if (this.appService.isMobileScreen) {
            this.router.navigate(['hit'], { relativeTo: this.route }).then();
        } else {
            const dialogRef = this.dialog.open(VvvoHinzufuegenHitDialogComponent, { minWidth: '600px' });
            dialogRef.afterClosed().subscribe({
                next: (response: HitLoginResponse) => {
                    if (response) {
                        this.openVvvoDetailsAfterHitLogin(response);
                    }
                },
            });
        }
    }

    editiereVvvo(vvvo: Client) {
        if (this.localStorageService.hasPermission(9102)) {
            if (this.appService.isMobileScreen) {
                console.log('router navigate 1');
                this.router.navigate(['details', vvvo.kunde_id], { relativeTo: this.route }).then();
            } else {
                this.openVvvoDetailsDialog(vvvo).afterClosed().subscribe({ next: () => this.ladeVvvos() });
            }
        }
    }

    freigabeTierarztpraxis(client: Client) {
        this.stammdatenService.freigabeTierarztpraxis(client);
    }

    hitPinAktualisieren(client: Client): void {
        this.dialog.open(HitPinAenderDialogComponent, { data: client }).afterClosed().subscribe({});
    }

    hasExternTierarzt(client: Client): boolean {
        return Number(client?.extern_tierarzt_id || 0) > 0;
    }

    externTierarztHinzufuegen(client: Client): void {
        this.openExternTierarztDialogAndAssign(client, false);
    }

    externTierarztEditieren(client: Client): void {
        const tierarztId = Number(client?.extern_tierarzt_id || 0);
        if (tierarztId > 0) {
            this.stammdatenService.getExternTierarzt(tierarztId).subscribe({
                next: tierarzt => this.openExternTierarztDialogAndAssign(client, true, tierarzt),
                error: () => this.openExternTierarztDialogAndAssign(client, true),
            });
            return;
        }
        this.openExternTierarztDialogAndAssign(client, true);
    }

    externTierarztEntfernen(client: Client): void {
        this.stammdatenService.unlinkExternTierarztFromKunde(client).subscribe({
            next: removed => {
                if (removed) {
                    this.ladeVvvos();
                }
            },
        });
    }

    futtermittellieferantAendern(client: Client): void {
        const lieferantId = Number((client as any)?.futtermittellieferant_id || 0);
        if (lieferantId > 0) {
            this.stammdatenService.getFuttermittellieferant(lieferantId).subscribe({
                next: lieferant => this.openLieferantDialogAndAssign(client, lieferant),
                error: () => this.openLieferantDialogAndAssign(client),
            });
            return;
        }
        this.openLieferantDialogAndAssign(client);
    }

    vvvoEntfernen(client: Client) {
        const isFreigegebenerBetrieb = this.selectedView === 'freigegebene';
        this.stammdatenService.removeVVVO(client, isFreigegebenerBetrieb).subscribe({
            next: res => {
                if (res) {
                    this.ladeVvvos();
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    sendMail(c: Client) {
        if (c.email) {
            const htmlAnchorElement = document.createElement('a');
            htmlAnchorElement.style.display = 'none';
            htmlAnchorElement.href = 'mailto:' + c.email;
            document.body.appendChild(htmlAnchorElement);
            htmlAnchorElement.click();
            // document.body.removeChild(htmlAnchorElement);
        }
    }

    public clearSearch(): void {
        this.searchControl.setValue('');
    }

    public getVollAdresse(vvvo: Client): string {
        if (!vvvo?.strasse && !vvvo?.plz && !vvvo?.ort) {
            return '';
        }
        return `${vvvo?.strasse || ''}${vvvo?.strasse && (vvvo?.plz || vvvo?.ort) ? ', ' : ''}${vvvo?.plz || ''} ${vvvo?.ort || ''}`.trim();
    }

    public getFilteredVvvos(): Client[] {
        const source = this.getCurrentSourceVvvos();
        const query = (this.searchControl.value ?? '').toString().trim().toLowerCase();
        let filtered = source;
        if (query) {
            filtered = source.filter(v => {
                return (
                    `${v?.bezeichnung ?? ''} ${v?.zusatz ?? ''}`.toLowerCase().includes(query) ||
                    (v?.vvvo ?? '').toLowerCase().includes(query) ||
                    (v?.betriebsart ?? '').toLowerCase().includes(query) ||
                    this.getVollAdresse(v).toLowerCase().includes(query) ||
                    (v?.email ?? '').toLowerCase().includes(query) ||
                    `${(v as any)?.telefon ?? ''} ${(v as any)?.telefon_1 ?? ''} ${(v as any)?.telefon_2 ?? ''}`
                        .toLowerCase()
                        .includes(query) ||
                    `${(v as any)?.mobil ?? ''} ${(v as any)?.mobil_1 ?? ''} ${(v as any)?.mobil_2 ?? ''}`
                        .toLowerCase()
                        .includes(query) ||
                    ((v as any)?.fax ?? '').toLowerCase().includes(query) ||
                    ((v as any)?.ortsteil ?? '').toLowerCase().includes(query) ||
                    ((v as any)?.sgs_nummer ?? '').toLowerCase().includes(query) ||
                    ((v as any)?.belege_email ?? '').toLowerCase().includes(query) ||
                    ((v as any)?.kp_abw_email ?? '').toLowerCase().includes(query) ||
                    ((v as any)?.futtermittellieferant ?? '').toLowerCase().includes(query) ||
                    `${(v as any)?.wirtschaftsjahr ?? ''}`.toLowerCase().includes(query)
                );
            });
        }
        return this.sortRows(filtered);
    }

    public getDesktopGridTemplate(): string {
        const contentColumns = this.getVisibleColumns().map(col => `${col.widthPx}px`);
        return [...contentColumns, 'minmax(0, 1fr)', `${this.actionColumnWidthPx}px`].join(' ');
    }

    public getDesktopMinWidthPx(): number {
        const contentWidth = this.getVisibleColumns().reduce((sum, col) => sum + col.widthPx, 0);
        const totalColumns = this.getVisibleColumns().length + 1;
        const totalGaps = Math.max(totalColumns - 1, 0) * this.desktopColumnGapPx;
        return contentWidth + this.actionColumnWidthPx + totalGaps;
    }

    public getVisibleColumns() {
        return this.columns.filter(col => col.available && col.visible);
    }

    public selectView(view: 'meine' | 'freigegebene') {
        this.selectedView = view;
        this.updateOptionalColumnsAvailability();
        this.scheduleHorizontalScrollbarSync();
    }

    public isSelectedView(view: 'meine' | 'freigegebene'): boolean {
        return this.selectedView === view;
    }

    public getMeineCount(): number {
        return this.meineVvvos?.length || 0;
    }

    public getFreigegebeneCount(): number {
        return this.freigegebeneVvvos?.length || 0;
    }

    public canToggleColumn(col: { alwaysVisible?: boolean; available: boolean }) {
        return col.available && !col.alwaysVisible;
    }

    public toggleColumn(key: string) {
        const col = this.columns.find(c => c.key === key);
        if (!col || !this.canToggleColumn(col)) {
            return;
        }
        col.visible = !col.visible;
        this.scheduleHorizontalScrollbarSync();
    }

    public setSort(key: string): void {
        if (this.sortKey === key) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortDirection = 'asc';
        }
        this.scheduleHorizontalScrollbarSync();
    }

    public isSortKey(key: string): boolean {
        return this.sortKey === key;
    }

    public getSortIcon(key: string): string {
        if (!this.isSortKey(key)) {
            return 'unfold_more';
        }
        return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
    }

    public getCellValue(c: Client, key: string): string {
        const row = c as any;
        if (key === 'bezeichnung') {
            return this.getBetriebText(c) || '-';
        }
        if (key === 'adresse') {
            return this.getVollAdresse(c) || '-';
        }
        if (key === 'telefon') {
            return (row?.telefon || row?.telefon_1 || '-') as string;
        }
        if (key === 'mobil') {
            return (row?.mobil || row?.mobil_1 || '-') as string;
        }
        if (key === 'belege_email') {
            return (row?.belege_email || '-') as string;
        }
        if (key === 'kp_abw_email') {
            return (row?.kp_abw_email || '-') as string;
        }
        return (row?.[key] || '-') as string;
    }

    public toggleExpandedRow(c: Client): void {
        const id = Number((c as any)?.kunde_id || 0);
        if (!id) {
            return;
        }
        this.expandedKundeId = this.expandedKundeId === id ? null : id;
        this.scheduleHorizontalScrollbarSync();
    }

    public isRowExpanded(c: Client): boolean {
        return this.expandedKundeId === Number((c as any)?.kunde_id || 0);
    }

    public toJaNein(value: any): string {
        return Number(value) > 0 ? 'Ja' : 'Nein';
    }

    public getRawValue(c: Client, key: string): any {
        return (c as any)?.[key];
    }

    public getCellTooltip(c: Client, key: string): string {
        if (key === 'email' || key === 'belege_email' || key === 'kp_abw_email') {
            const raw = this.getRawValue(c, key);
            return raw ? `${raw}` : '';
        }
        const value = this.getCellValue(c, key);
        return value && value !== '-' ? value : '';
    }

    public getBetriebText(c: Client): string {
        const base = String(c?.bezeichnung_final || c?.bezeichnung || '').trim();
        const zusatz = String(c?.zusatz_final || c?.zusatz || '').trim();
        if (!base) {
            return zusatz;
        }
        return zusatz ? `${base} – ${zusatz}` : base;
    }

    public showBetriebTooltip(c: Client): boolean {
        return this.getBetriebText(c).length > 35;
    }

    public showAdresseTooltip(c: Client): boolean {
        return this.getVollAdresse(c).length > 50;
    }

    public isTextOverflow(el: HTMLElement | null): boolean {
        if (!el) {
            return false;
        }
        return el.scrollWidth > el.clientWidth;
    }

    public forceHorizontalScrollbarSync(): void {
        this.startInitialSyncLoop();
    }

    public get isMobileScreen(): boolean {
        return this.appService.isMobileScreen;
    }

    public goBack(): void {
        window.history.back();
    }

    private updateOptionalColumnsAvailability(): void {
        const source = this.getCurrentSourceVvvos();
        for (const col of this.columns) {
            if (col.alwaysVisible) {
                col.available = true;
                continue;
            }
            const keys = col.dataKeys?.length ? col.dataKeys : [col.key];
            col.available = source.some(row => this.hasAnyValue(row, keys));
            if (!col.available) {
                col.visible = false;
            }
        }
    }

    private getCurrentSourceVvvos(): Client[] {
        if (this.selectedView === 'freigegebene') {
            return this.freigegebeneVvvos ?? [];
        }
        return this.meineVvvos ?? [];
    }

    private hasAnyValue(row: any, keys: string[]): boolean {
        for (const key of keys) {
            const value = row?.[key];
            if (value === null || value === undefined) {
                continue;
            }
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                if (!normalized || normalized === 'null' || normalized === 'undefined') {
                    continue;
                }
            }
            return true;
        }
        return false;
    }

    onTableHorizontalScroll() {
        if (this.syncFromBottom) {
            return;
        }
        const tableEl = this.tableScrollContainer?.nativeElement;
        const bottomEl = this.bottomScrollbar?.nativeElement;
        if (!tableEl || !bottomEl) {
            return;
        }
        this.syncFromTable = true;
        bottomEl.scrollLeft = tableEl.scrollLeft;
        this.syncFromTable = false;
    }

    onBottomScrollbarScroll() {
        if (this.syncFromTable) {
            return;
        }
        const tableEl = this.tableScrollContainer?.nativeElement;
        const bottomEl = this.bottomScrollbar?.nativeElement;
        if (!tableEl || !bottomEl) {
            return;
        }
        this.syncFromBottom = true;
        tableEl.scrollLeft = bottomEl.scrollLeft;
        this.syncFromBottom = false;
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.syncHorizontalScrollbar();
    }

    private syncHorizontalScrollbar() {
        const tableEl = this.tableScrollContainer?.nativeElement;
        const bottomEl = this.bottomScrollbar?.nativeElement;
        if (!tableEl || !bottomEl) {
            return;
        }
        const rect = tableEl.getBoundingClientRect();
        this.bottomScrollbarLeft = rect.left;
        this.bottomScrollbarWidth = rect.width;
        this.horizontalScrollWidth = tableEl.scrollWidth;
        this.showHorizontalScrollbar = tableEl.scrollWidth > tableEl.clientWidth;
        bottomEl.scrollLeft = tableEl.scrollLeft;
    }

    private initTableResizeObserver() {
        const tableEl = this.tableScrollContainer?.nativeElement;
        if (!tableEl || typeof ResizeObserver === 'undefined') {
            return;
        }
        this.tableResizeObserver?.disconnect();
        this.tableResizeObserver = new ResizeObserver(() => this.syncHorizontalScrollbar());
        this.tableResizeObserver.observe(tableEl);
    }

    private initTableVisibilityObserver() {
        const tableEl = this.tableScrollContainer?.nativeElement;
        if (!tableEl || typeof IntersectionObserver === 'undefined') {
            return;
        }
        this.tableVisibilityObserver?.disconnect();
        this.tableVisibilityObserver = new IntersectionObserver(entries => {
            const isVisible = entries.some(entry => entry.isIntersecting);
            if (isVisible) {
                this.startInitialSyncLoop();
            }
        });
        this.tableVisibilityObserver.observe(tableEl);
    }

    private scheduleHorizontalScrollbarSync(): void {
        this.clearScheduledScrollbarSync();
        const delays = [0, 80, 220];
        this.syncTimeoutHandles = delays.map(delay =>
            window.setTimeout(() => {
                this.syncHorizontalScrollbar();
            }, delay),
        );
    }

    private clearScheduledScrollbarSync(): void {
        for (const timeoutHandle of this.syncTimeoutHandles) {
            clearTimeout(timeoutHandle);
        }
        this.syncTimeoutHandles = [];
    }

    private startInitialSyncLoop(): void {
        this.scheduleHorizontalScrollbarSync();
        this.stopInitialSyncLoop();
        let attemptsLeft = 20;
        this.initialSyncIntervalHandle = window.setInterval(() => {
            this.syncHorizontalScrollbar();
            attemptsLeft--;
            if (attemptsLeft <= 0) {
                this.stopInitialSyncLoop();
            }
        }, 100);
    }

    private stopInitialSyncLoop(): void {
        if (this.initialSyncIntervalHandle !== undefined) {
            clearInterval(this.initialSyncIntervalHandle);
            this.initialSyncIntervalHandle = undefined;
        }
    }

    private openVvvoDetailsAfterHitLogin(response: HitLoginResponse): void {
        const vvvoFromHit = `${response?.vvvo ?? ''}`.trim();
        const withHitPin = (kunde: Client): Client => {
            if (response?.pin) {
                kunde.pin = response.pin;
            }
            if (vvvoFromHit && !kunde.vvvo) {
                kunde.vvvo = vvvoFromHit;
            }
            return kunde;
        };
        const existing = (this.vvvos || []).find(v => `${v?.vvvo ?? ''}`.trim() === vvvoFromHit);

        if (existing?.kunde_id) {
            this.stammdatenService.getKunde(existing.kunde_id).subscribe({
                next: kunde => this.openAndPersistVvvoDialog(withHitPin(kunde), false),
                error: () => this.openAndPersistVvvoDialog(withHitPin(HitLoginResponse.generateClient(response)), false),
            });
            return;
        }

        this.stammdatenService.searchKundeByVvvo(vvvoFromHit).subscribe({
            next: result => {
                const kundeId = Number(result?.records?.[0]?.kunde_id || 0);
                if (kundeId > 0) {
                    this.stammdatenService.getKunde(kundeId).subscribe({
                        next: kunde => this.openAndPersistVvvoDialog(withHitPin(kunde), false),
                        error: () =>
                            this.openAndPersistVvvoDialog(withHitPin(HitLoginResponse.generateClient(response)), false),
                    });
                    return;
                }
                this.openAndPersistVvvoDialog(withHitPin(HitLoginResponse.generateClient(response)), false);
            },
            error: () => this.openAndPersistVvvoDialog(withHitPin(HitLoginResponse.generateClient(response)), false),
        });
    }

    private openAndPersistVvvoDialog(client: Client, emailRequired = false): void {
        this.openVvvoDetailsDialog(client, emailRequired).afterClosed().subscribe({
            next: (updatedClient: Client) => {
                if (!updatedClient) {
                    return;
                }
                // Speichern passiert bereits in vvvo-details.updateKunde(); hier nur Liste aktualisieren.
                this.ladeVvvos();
                this.messageService.infoMessage('Betrieb erfolgreich gespeichert!');
            },
        });
    }

    private openVvvoDetailsDialog(vvvo: Client, emailRequired = false) {
        return this.dialog.open(VVVODetailsDialogComponent, {
            data: { kunde: vvvo, emailRequired },
            width: '76vw',
            maxWidth: '95vw',
            autoFocus: false,
        });
    }

    private openExternTierarztDialogAndAssign(
        client: Client,
        editMode: boolean,
        externTierarzt?: ExternTierarzt,
    ): void {
        this.dialog
            .open(ExternTierarztDetailsDialogComponent, {
                minWidth: this.appService?.isMobileScreen ? '100vw' : 'min(720px, 96vw)',
                width: this.appService?.isMobileScreen ? '100%' : 'min(720px, 96vw)',
                maxWidth: '96vw',
                maxHeight: '92vh',
                panelClass: 'extern-tierarzt-dialog-panel',
                autoFocus: false,
                data: { externTierarzt, editMode },
            })
            .afterClosed()
            .subscribe({
                next: (result: ExternTierarzt) => {
                    if (!result?.extern_tierarzt_id) {
                        return;
                    }
                    const kundeId = Number(client?.kunde_id || 0);
                    if (!kundeId) {
                        return;
                    }
                    this.stammdatenService.assignExternTierarztToKunde(kundeId, result.extern_tierarzt_id).subscribe({
                        next: () => {
                            this.messageService.infoMessage(
                                editMode ? 'Tierarzt erfolgreich geändert!' : 'Tierarzt erfolgreich zugeordnet!',
                            );
                            this.ladeVvvos();
                        },
                        error: err => this.messageService.errorMessage('Fehler!', err),
                    });
                },
            });
    }

    private openLieferantDialogAndAssign(client: Client, futtermittellieferant?: Futtermittellieferant): void {
        this.dialog
            .open(LieferantDetailsDialogComponent, {
                minWidth: this.appService?.isMobileScreen ? '100vw' : '460px',
                width: this.appService?.isMobileScreen ? '100%' : '',
                data: futtermittellieferant ? { futtermittellieferant } : undefined,
            })
            .afterClosed()
            .subscribe({
                next: (result: Futtermittellieferant) => {
                    if (!result?.futtermittellieferant_id) {
                        return;
                    }
                    const kundeId = Number((client as any)?.kunde_id || 0);
                    if (!kundeId) {
                        return;
                    }
                    this.stammdatenService
                        .setFuttermittellieferantFavorit(kundeId, result.futtermittellieferant_id)
                        .subscribe({
                            next: () => {
                                this.messageService.infoMessage('Futtermittellieferant erfolgreich zugeordnet!');
                                this.ladeVvvos();
                            },
                            error: err => this.messageService.errorMessage('Fehler!', err),
                        });
                },
            });
    }

    private sortRows(rows: Client[]): Client[] {
        const sorted = [...rows];
        sorted.sort((a, b) => {
            const av = (this.getCellValue(a, this.sortKey) || '').toString().toLowerCase();
            const bv = (this.getCellValue(b, this.sortKey) || '').toString().toLowerCase();
            if (av < bv) {
                return this.sortDirection === 'asc' ? -1 : 1;
            }
            if (av > bv) {
                return this.sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });
        return sorted;
    }
}
